import React, { useEffect, useState } from 'react';
import { Zap, CheckCircle, XCircle } from 'lucide-react';
import { FUNCTIONS_URL } from '../lib/supabase';

// TikTok, kullanıcıyı /tiktok/callback?code=...&state=... adresine yönlendirir.
// Bu sayfa kodu yakalar, tiktok-exchange edge function'ına POST eder,
// ardından ana uygulamaya yönlendirir.

export default function TikTokCallback() {
  const [status, setStatus] = useState('loading'); // 'loading' | 'success' | 'error'
  const [errorMsg, setErrorMsg] = useState('');

  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    const code = params.get('code');
    const state = params.get('state');
    const error = params.get('error');

    if (error || !code || !state) {
      setStatus('error');
      setErrorMsg(error || 'Missing OAuth parameters');
      setTimeout(() => { window.location.href = '/?tiktok=error'; }, 2500);
      return;
    }

    (async () => {
      try {
        const res = await fetch(`${FUNCTIONS_URL}/tiktok-exchange`, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ code, state }),
        });

        const data = await res.json();
        if (!res.ok || data.error) {
          throw new Error(data.error || 'Exchange failed');
        }

        setStatus('success');
        setTimeout(() => { window.location.href = '/?tiktok=success'; }, 1500);
      } catch (e) {
        setStatus('error');
        setErrorMsg(e.message);
        setTimeout(() => { window.location.href = '/?tiktok=error'; }, 2500);
      }
    })();
  }, []);

  return (
    <div style={s.page}>
      <div style={s.card}>
        <div style={s.logo}>
          <div style={s.logoIcon}><Zap size={20} color="#fff" fill="#fff" /></div>
          <span style={s.logoText}>VidFlow</span>
        </div>

        {status === 'loading' && (
          <>
            <div style={s.spinner} />
            <p style={s.title}>Connecting your TikTok account...</p>
            <p style={s.sub}>Please wait a moment.</p>
          </>
        )}

        {status === 'success' && (
          <>
            <CheckCircle size={48} color="var(--green)" style={{ margin: '8px auto' }} />
            <p style={s.title}>TikTok connected!</p>
            <p style={s.sub}>Redirecting you back to the app...</p>
          </>
        )}

        {status === 'error' && (
          <>
            <XCircle size={48} color="var(--pink)" style={{ margin: '8px auto' }} />
            <p style={s.title}>Connection failed</p>
            <p style={s.sub}>{errorMsg || 'Something went wrong. Redirecting...'}</p>
          </>
        )}
      </div>
      <style>{`
        @keyframes spin { from { transform: rotate(0deg); } to { transform: rotate(360deg); } }
      `}</style>
    </div>
  );
}

const s = {
  page: {
    minHeight: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center',
    background: 'var(--bg-primary)',
  },
  card: {
    background: 'var(--bg-card)', border: '1px solid var(--border)',
    borderRadius: 20, padding: '48px 40px', textAlign: 'center',
    maxWidth: 360, width: '100%', display: 'flex', flexDirection: 'column',
    alignItems: 'center', gap: 12,
    boxShadow: '0 24px 60px rgba(0,0,0,0.5)',
  },
  logo: { display: 'flex', alignItems: 'center', gap: 10, marginBottom: 16 },
  logoIcon: {
    width: 36, height: 36, borderRadius: 10,
    background: 'linear-gradient(135deg, var(--accent), var(--pink))',
    display: 'flex', alignItems: 'center', justifyContent: 'center',
  },
  logoText: { fontSize: 18, fontWeight: 700, color: 'var(--text-primary)' },
  spinner: {
    width: 48, height: 48, borderRadius: '50%',
    border: '3px solid var(--border)',
    borderTopColor: 'var(--accent)',
    animation: 'spin 0.9s linear infinite',
    margin: '8px auto',
  },
  title: { fontSize: 18, fontWeight: 700, color: 'var(--text-primary)', margin: 0 },
  sub: { fontSize: 14, color: 'var(--text-secondary)', margin: 0 },
};
